import React from "react";
import { Box, Grid, IconButton, InputAdornment, Stack } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { CustomTextField } from "../../../../components/formsComponents";
import { FieldLabel } from "../components/FieldLabel";
import { IFormikBridge } from "../BusinessOnboard.types";

interface IProfileStepProps extends IFormikBridge {
  showPassword: boolean;
  onTogglePassword: () => void;
  submitAttempted: boolean;
}

/** Step 3 — Account credentials: name, email, password, confirm password. */
export const ProfileStep: React.FC<IProfileStepProps> = ({
  values,
  errors,
  handleChange,
  showPassword,
  onTogglePassword,
  submitAttempted,
}) => {
  const inputSx = {
    "& .MuiInputBase-root": { borderRadius: "10px" },
  };

  const passwordAdornment = (
    <InputAdornment position="end">
      <IconButton onClick={onTogglePassword} edge="end">
        {showPassword ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <FieldLabel label="First name" required />
        <CustomTextField
          placeholder="First name"
          fullWidth
          name="first_name"
          value={values.first_name}
          onChange={handleChange}
          error={submitAttempted && !!errors.first_name}
          helperText={submitAttempted ? errors.first_name : ""}
          sx={inputSx}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FieldLabel label="Last name" />
        <CustomTextField
          placeholder="Last name"
          fullWidth
          name="last_name"
          value={values.last_name}
          onChange={handleChange}
          sx={inputSx}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldLabel label="Email" required />
        <CustomTextField
          placeholder="you@company.com"
          fullWidth
          name="email"
          value={values.email}
          onChange={handleChange}
          error={submitAttempted && !!errors.email}
          helperText={submitAttempted ? errors.email : ""}
          sx={inputSx}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FieldLabel label="Password" required />
        <CustomTextField
          type={showPassword ? "text" : "password"}
          placeholder="8+ characters"
          fullWidth
          name="user_password"
          value={values.user_password}
          onChange={handleChange}
          error={submitAttempted && !!errors.user_password}
          helperText={submitAttempted ? errors.user_password : ""}
          InputProps={{ endAdornment: passwordAdornment }}
          sx={inputSx}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FieldLabel label="Confirm password" required />
        <CustomTextField
          type={showPassword ? "text" : "password"}
          placeholder="8+ characters"
          fullWidth
          name="confirm_password"
          value={values.confirm_password}
          onChange={handleChange}
          error={submitAttempted && !!errors.confirm_password}
          helperText={submitAttempted ? errors.confirm_password : ""}
          InputProps={{ endAdornment: passwordAdornment }}
          sx={inputSx}
        />
      </Grid>
    </Grid>
  );
};
